module.exports = __webpack_public_path__ + "static/img/fx01.3814d29.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fx01.png
// module id = IAVD
// module chunks = 0